import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ShaServicesModule } from '@applications/sha-services';
import { CommonMaterialComponentsModule } from '@quorum/common-material-components';
import { CommonPipesModule } from '@quorum/common-pipes';
//import {AssociateCardComponent} from 'lib/crm-prospects-ng-ui/src/lib/associate-card/associate.card.component';
import { CrmAssociateCardNgUiModule } from '@quorum/crm-prospects-ng-ui';
import { ShaAssociatesNgUiModule } from '@quorum/sha-associates-ng-ui';
import { ShaComponentsNgUiModule } from '@quorum/sha-components-ng-ui';
import { ShaServiceAppointmentsNgUiModule } from '@quorum/sha-service-appointments-ng-ui';
import { ShaServiceQuotesNgUiModule } from '@quorum/sha-service-quotes-ng-ui';
import { ShaVehiclesNgUiModule } from '@quorum/sha-vehicles-ng-ui';
import { ShaWorkOrdersNgUiModule } from '@quorum/sha-work-orders-ng-ui';
import { TextMaskModule } from 'angular2-text-mask';
import { NgPipesModule } from 'ngx-pipes';
import { AcceptQuoteLineDialogComponent } from './accept-quote-line-dialog/accept-quote-line-dialog.component';
// eslint-disable-next-line max-len
import { AppointmentCaseConfirmDeleteDialogComponent } from './appointment-case-confirm-delete-dialog/appointment-case-confirm-delete-dialog.component';
// eslint-disable-next-line max-len
import { AppointmentConfirmDeleteDialogComponent } from './appointment-confirm-delete-dialog/appointment-confirm-delete-dialog.component';
// eslint-disable-next-line max-len
import { AppointmentConfirmSendConfirmationDialogComponent } from './appointment-confirm-send-confirmation-dialog/appointment-confirm-send-confirmation-dialog.component';
// eslint-disable-next-line max-len
import { AppointmentConfirmationDialogComponent } from './appointment-confirmation-dialog/appointment-confirmation-dialog.component';
// eslint-disable-next-line max-len
import { AppointmentFreeformVehicleComponent } from './appointment-freeform-vehicle/appointment-freeform-vehicle.component';
import { AppointmentMatchSummaryComponent } from './appointment-match-summary/appointment-match-summary.component';
import { AppointmentSummaryComponent } from './appointment-summary/appointment-summary.component';
import { AppointmentComponent } from './appointment/appointment.component';
import { AppointmentsListFilterComponent } from './appointments-list-filter/appointments-list-filter.component';
import { ApprovalConfirmationProgressComponent } from './approval-confirmation-progress/approval-confirmation-progress.component';
import { BarcodeScannerComponent } from './barcode-scanner/barcode-scanner.component';
import { CreateAppointmentComponent } from './create-appointment/create-appointment.component';
import { CreateVehicleComponent } from './create-vehicle/create-vehicle.component';
import { CustomerNotesDialogComponent } from './customer-notes-dialog/customer-notes-dialog.component';
import { FreeformAppointmentMatchingComponent } from './freeform-appointment-matching/freeform-appointment-matching.component';
import { GmDashboardComponent } from './gm-dashboard/gm-dashboard.component';
import { FordDashboardComponent } from './ford-dashboard/ford-dashboard.component';
import { ToyotaDashboardComponent } from './toyota-dashboard/toyota-dashboard.component';
import { ChryslerDashboardComponent } from './chrysler-dashboard/chrysler-dashboard.component';
import { LicensePlateScannerComponent } from './license-plate-scanner/license-plate-scanner.component';
import { NoLicenseComponent } from './no-license/no-license.component';
import { QuoteApprovalLineItemComponent } from './quote-approval-line-item/quote-approval-line-item.component';
import { QuoteApprovalLineComponent } from './quote-approval-line/quote-approval-line.component';
import { RecallDialogComponent } from './recall-dialog/recall-dialog.component';
import { ScannerDialogComponent } from './scanner-dialog/scanner-dialog.component';
// eslint-disable-next-line max-len
import { ServiceAppointmentDeclinedOperationsComponent } from './service-appointment-declined-operations/service-appointment-declined-operations.component';
import { ServiceHistoryComponent } from './service-history/service-history.component';
import { ShellComponent } from './shell/shell.component';
import { SignaturePadComponent } from './signature-pad/signature-pad.component';
import { TechLandingComponent } from './tech-landing/tech-landing.component';
import { TodaysAppointmentsComponent } from './todays-appointments/todays-appointments.component';
import { VehicleCardComponent } from './vehicle-card/vehicle-card.component';
import { VehicleMatchCardComponent } from './vehicle-match-card/vehicle-match-card.component';
import { VehicleComponent } from './vehicle/vehicle.component';
import { VinScannerComponent } from './vin-scanner/vin-scanner.component';
import { WorkOrderCreationDialogComponent } from './work-order-creation-dialog/work-order-creation-dialog.component';
// eslint-disable-next-line max-len
import { WorkOrderDeclinedOperationsComponent } from './work-order-declined-operations/work-order-declined-operations.component';
import { WorkOrderComponent } from './work-order/work-order.component';
import { CreateWorkorderConfirmationComponent } from './create-workorder-confirmation/create-workorder-confirmation.component';
import { MatTableModule } from '@angular/material/table';
import { ToyotaScheduleComponent } from './toyota-schedule/toyota-schedule.component';
import { ToyotaDeclinedReasonDialogComponent } from './toyota-declined-reason-dialog/toyota-declined-reason-dialog.component';
import { SvcSignaturePadModule } from './svc-signature-pad.module';
import { WorkOrderHeaderComponent } from './work-order-header/work-order-header.component';
import { WorkOrderInspectionShellComponent } from './work-order-inspection-shell/work-order-inspection-shell.component';
import { XsrLegacyVipModule } from '@quorum/xsr-legacy-vip';
import { VehicleMediaGalleryComponent } from './vehicle-media-gallery/vehicle-media-gallery.component';
import { NissanDashboardComponent } from './nissan-dashboard/nissan.dashboard.component';
import { HyundaiDashboardComponent } from './hyundai-dashboard/hyundai.dashboard.component';
import { DashboardShellComponent } from './dashboard-shell/dashboard-shell.component';
import { GetCampaignOperationPipe } from './get-campaign-operation.pipe';
import { VehicleOtherWarrantyComponent } from './vehicle-other-warranty/vehicle-other-warranty.component';
import { PartKitSelectionComponent } from './part-kit-selection/part-kit-selection.component';
import { ActionBarComponent } from './action-bar/action-bar.component';
import { SharedDirectivesModule } from '@quorum/sha-directives';
import { GmMyRewardsModule } from '@quorum/gm-my-rewards';
import { EditVehicleDialogComponent } from './edit-vehicle-dialog/edit-vehicle-dialog.component';
import { EditCustomerDialogComponent } from './edit-customer-dialog/edit-customer-dialog.component';
import { VehicleWarrantyComponent } from './vehicle-warranty/vehicle-warranty.component';
import { EditAppointmentDialogComponent } from './edit-appointment-dialog/edit-appointment-dialog.component';
import { DashboardDetailsDialogComponent } from './dashboard-details-dialog/dashboard-details-dialog.component';
import { CustomerSignatureDialogComponent } from './customer-signature-dialog/customer-signature-dialog.component';
import { SettingsComponent } from './settings/settings.component';
import { SettingsNavComponent } from './settings/settings-nav.component';
import { MotorMappingComponent } from './motor-mapping/motor-mapping.component';
import { MotorMappingEditDialogComponent } from './motor-mapping/motor-mapping-edit-dialog.component';
import { MotorTaxonomyService } from './motor-mapping/motor-taxonomy.service';
import { DealerRecommendationsComponent } from './dealer-recommendations/dealer-recommendations.component';
import { DealerRecommendationEditDialogComponent } from './dealer-recommendations/dealer-recommendation-edit-dialog.component';

@NgModule({
  imports: [
    MatButtonToggleModule,
    ShaServicesModule,
    CommonModule,
    CommonPipesModule,
    FormsModule,
    ReactiveFormsModule,
    CommonMaterialComponentsModule,
    FlexLayoutModule,
    MatSidenavModule,
    RouterModule,
    TextMaskModule,
    ShaComponentsNgUiModule,
    ShaVehiclesNgUiModule,
    ShaAssociatesNgUiModule,
    NgPipesModule,
    ShaServiceAppointmentsNgUiModule,
    ShaWorkOrdersNgUiModule,
    ShaServiceQuotesNgUiModule,
    OverlayModule,
    CrmAssociateCardNgUiModule,
    MatTableModule,
    SvcSignaturePadModule,
    SharedDirectivesModule,
    GmMyRewardsModule,
    XsrLegacyVipModule,
  ],
  declarations: [
    ShellComponent,
    VehicleComponent,
    WorkOrderComponent,
    AppointmentComponent,
    CreateVehicleComponent,
    ScannerDialogComponent,
    BarcodeScannerComponent,
    TodaysAppointmentsComponent,
    AppointmentSummaryComponent,
    ServiceHistoryComponent,
    CreateAppointmentComponent,
    AcceptQuoteLineDialogComponent,
    VehicleCardComponent,
    CustomerNotesDialogComponent,
    LicensePlateScannerComponent,
    VinScannerComponent,
    WorkOrderCreationDialogComponent,
    AppointmentConfirmationDialogComponent,
    AppointmentFreeformVehicleComponent,
    ServiceAppointmentDeclinedOperationsComponent,
    WorkOrderDeclinedOperationsComponent,
    AppointmentCaseConfirmDeleteDialogComponent,
    AppointmentConfirmDeleteDialogComponent,
    AppointmentConfirmSendConfirmationDialogComponent,
    GmDashboardComponent,
    FordDashboardComponent,
    ToyotaDashboardComponent,
    ToyotaScheduleComponent,
    ChryslerDashboardComponent,
    QuoteApprovalLineComponent,
    AppointmentsListFilterComponent,
    QuoteApprovalLineItemComponent,
    ApprovalConfirmationProgressComponent,
    RecallDialogComponent,
    TechLandingComponent,
    NoLicenseComponent,
    FreeformAppointmentMatchingComponent,
    VehicleMatchCardComponent,
    AppointmentMatchSummaryComponent,
    CreateWorkorderConfirmationComponent,
    ToyotaDeclinedReasonDialogComponent,
    WorkOrderHeaderComponent,
    WorkOrderInspectionShellComponent,
    VehicleMediaGalleryComponent,
    NissanDashboardComponent,
    HyundaiDashboardComponent,
    DashboardShellComponent,
    GetCampaignOperationPipe,
    VehicleOtherWarrantyComponent,
    PartKitSelectionComponent,
    ActionBarComponent,
    EditVehicleDialogComponent,
    EditCustomerDialogComponent,
    VehicleWarrantyComponent,
    DashboardDetailsDialogComponent,
    EditAppointmentDialogComponent,
    CustomerSignatureDialogComponent,
    SettingsComponent,
    SettingsNavComponent,
    MotorMappingComponent,
    MotorMappingEditDialogComponent,
    DealerRecommendationsComponent,
    DealerRecommendationEditDialogComponent,
  ],
  exports: [
    ShellComponent,
    ScannerDialogComponent,
    TodaysAppointmentsComponent,
    AppointmentSummaryComponent,
    ServiceHistoryComponent,
    AcceptQuoteLineDialogComponent,
    CustomerNotesDialogComponent,
    LicensePlateScannerComponent,
    VinScannerComponent,
    WorkOrderCreationDialogComponent,
    AppointmentConfirmationDialogComponent,
    AppointmentFreeformVehicleComponent,
    AppointmentCaseConfirmDeleteDialogComponent,
    AppointmentConfirmDeleteDialogComponent,
    AppointmentConfirmSendConfirmationDialogComponent,
    GmDashboardComponent,
    FordDashboardComponent,
    ToyotaDashboardComponent,
    ToyotaScheduleComponent,
    ChryslerDashboardComponent,
    AppointmentsListFilterComponent,
    QuoteApprovalLineComponent,
    QuoteApprovalLineItemComponent,
    RecallDialogComponent,
    CreateWorkorderConfirmationComponent,
    WorkOrderHeaderComponent,
    WorkOrderInspectionShellComponent,
    NissanDashboardComponent,
    HyundaiDashboardComponent,
    VehicleOtherWarrantyComponent,
    ActionBarComponent,
    VehicleWarrantyComponent,
    DashboardDetailsDialogComponent,
    CustomerSignatureDialogComponent,
    SettingsComponent,
  ],
  providers: [MotorTaxonomyService],
})
export class SvcServiceLaneNgUiModule {}
